import React, { useState, useEffect } from 'react';
import { Loader2, AlertTriangle } from 'lucide-react';

const ConfirmDelete = ({ onConfirm, onCancel }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  // Handle escape key to close modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && !isDeleting) {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onCancel, isDeleting]);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      // The modal will be closed by the parent component after successful deletion
    } catch (error) {
      setIsDeleting(false);
    }
  };

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center z-[6000] bg-black/90 backdrop-blur"
      onClick={(e) => e.target === e.currentTarget && !isDeleting && onCancel()}
    >
      <div className="bg-white/10 backdrop-blur-lg rounded-xl z-[6500] overflow-hidden border border-white/10 w-[90%] max-w-md transform transition-all duration-200 ease-out">
        <div className="p-6 text-center space-y-4">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 rounded-full bg-red-100/10 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-500" />
            </div>
          </div>

          <h3 className="text-xl font-bold text-white">تأكيد الحذف</h3>
          
          <p className="text-gray-300">
          هل أنت متأكد من أنك تريد حذف هذا المستوى؟ لا يمكن التراجع عن هذا الإجراء.
          </p>

          <div className="flex justify-center gap-4 pt-4">
            <button
              onClick={onCancel}
              disabled={isDeleting}
              className="px-6 py-2 rounded-lg bg-gray-600 text-white hover:bg-gray-700 
                transition-colors disabled:opacity-50 focus:outline-none focus:ring-2 
                focus:ring-gray-500 focus:ring-offset-2 focus:ring-offset-black"
            >
              الغاء
            </button>
            <button
              onClick={handleConfirm}
              disabled={isDeleting}
              className="px-6 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 
                transition-colors disabled:opacity-50 flex items-center gap-2
                focus:outline-none focus:ring-2 focus:ring-red-500 
                focus:ring-offset-2 focus:ring-offset-black"
            >
              {isDeleting ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  جارى الحذف....
                </>
              ) : (
                ' الحذف'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDelete;